// @ts-nocheck
export enum CHECKIN {
  mileage = 'mileage',
  condition = 'condition',
  garage = 'garage',
}

export const CHECKIN_LIST = [CHECKIN.mileage, CHECKIN.condition];

export enum ADDRESS_CHECK_IN_DOC_TYPES {
  utilityBill = 'UtilityBill',
  payCheck = 'PayCheck',
  financialStatement = 'FinancialStatement',
  saleDeed = 'SaleDeed',
  leaseAgreement = 'LeaseAgreement',
}

export enum PHOTOS_TYPES {
  frontView = 'FrontView',
  AlternateView = 'AlternateView',
}

export enum FILE_TYPE {
  document = 'DOCUMENT',
  gallery = 'GALLERY',
  camera = 'CAMERA',
}

export enum CHECK_IN_STATUS {
  confirmed = 'Confirmed',
  declined = 'Declined',
  onHold = 'OnHold',
  pending = 'Pending',
}

export enum CONDITION_PHOTO_TYPES {
  back = 'Back',
  front = 'Front',
  driverSide = 'DriverSide',
  driverSideFront = 'DriverSideFront',
  driverSideBack = 'DriverSideBack',
  passengerSide = 'PassengerSide',
  passengerSideFront = 'PassengerSideFront',
  passengerSideBack = 'PassengerSideBack',
}

export enum CONDITION_PHOTO_LABEL {
  Back = 'back',
  Front = 'front',
  DriverSide = 'driver_side',
  DriverSideFront = 'driver_side_front',
  DriverSideBack = 'driver_side_back',
  PassengerSide = 'passenger_side',
  PassengerSideFront = 'passenger_side_front',
  PassengerSideBack = 'passenger_side_back',
}
